/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useContext, useRef } from "react";
import BasemapGallary from "@arcgis/core/widgets/BasemapGallery";
import Button from "calcite-react/Button";
import Basemap from "@arcgis/core/Basemap";
import BasemapIcon from "calcite-ui-icons-react/BasemapIcon";

import "./BasemapSelector.scss";
import { MapContext } from "../../context/MapContext";

function BasemapSelector(props) {
  const {
    basemapOpen,
    setBasemapOpen,
    setBasemap,
    measureToolOpen,
    setMeasureToolOpen,
    areaToolOpen,
    setAreaToolOpen,
  } = props;
  const basemapDiv = useRef(null);
  const [mapObject] = useContext(MapContext);

  useEffect(() => {
    if (basemapDiv.current && mapObject?.view) {
      const gallery = new BasemapGallary({
        container: basemapDiv.current,
        view: mapObject.view,
        source: [
          Basemap.fromId("oceans"),
          Basemap.fromId("hybrid"),
          Basemap.fromId("gray-vector"),
          Basemap.fromId("dark-gray-vector"),
          Basemap.fromId("national-geographic"),
          Basemap.fromId("satellite"),
          Basemap.fromId("streets-vector"),
          Basemap.fromId("terrain"),
          Basemap.fromId("topo-vector"),
        ],
      });

      gallery.watch("activeBasemap", (newValue) => setBasemap(newValue.id));
    }
  }, [basemapDiv, mapObject?.view, setBasemap]);

  const toggleBasemapGallery = (b) => {
    if (b) {
      measureToolOpen && setMeasureToolOpen(false);
      areaToolOpen && setAreaToolOpen(false);
    }
    setBasemapOpen(b);
  };

  return (
    <div className="basemapSelector">
      <Button
        className={`basemapToggle ${basemapOpen ? " active" : ""}`}
        title="Basemap Selector"
        onClick={() => toggleBasemapGallery(!basemapOpen)}
        icon={<BasemapIcon size={16} />}
      ></Button>
      <div
        className={basemapOpen ? "basemapContainer" : "basemapContainer hidden"}
        ref={basemapDiv}
        onClick={() => setBasemapOpen(false)}
      ></div>
    </div>
  );
}

export default BasemapSelector;
